import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { formatCurrency } from '@/utils/orderValue';
import { isDeliveryCommissionEntry } from '@/utils/deliveryCommission';

export default function DriverDeliveryCostField({ value = '', savedValue, onChange, editing = false,
  disabled = false, available = true }) {
  return (
    <section aria-label="Delivery costs" className="border-t border-stone-200 pt-6 space-y-3">
      <h3 className="text-base font-semibold text-stone-900">Delivery costs</h3>
      <div className="space-y-2">
        {editing && available ? <>
          <Label htmlFor="shop-delivery-commission">Driver cost per delivery</Label>
          <div className="relative max-w-xs">
            <span aria-hidden="true" className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-stone-500">$</span>
            <Input id="shop-delivery-commission" type="text" inputMode="decimal" autoComplete="off"
              placeholder="Not set" value={value} onChange={event => {
                if (isDeliveryCommissionEntry(event.target.value)) onChange(event.target.value);
              }} onPaste={event => {
                const input = event.currentTarget;
                const next = value.slice(0, input.selectionStart) + event.clipboardData.getData('text')
                  + value.slice(input.selectionEnd);
                if (!isDeliveryCommissionEntry(next)) event.preventDefault();
              }} disabled={disabled} className="pl-7" aria-describedby="driver-cost-description delivery-commission-note" />
          </div>
        </> : <>
          <p className="text-sm font-medium text-stone-700">Driver cost per delivery</p>
          <p data-testid="saved-delivery-commission" className="text-stone-900">
            {!available ? 'Unavailable offline' : savedValue === undefined ? 'Not set' : formatCurrency(savedValue)}
          </p>
        </>}
        <p id="driver-cost-description" className="text-sm text-stone-500">
          The amount your shop pays the driver, not the delivery fee charged to the customer.
        </p>
      </div>
      <p id="delivery-commission-note" className="text-sm text-stone-500">
        {editing && available ? 'Use digits and up to two decimal places. Leave blank to clear the saved amount. ' : ''}
        Not yet used in income calculations.
      </p>
    </section>
  );
}
